
import version_2 from '@/assets/images/digital_learning_ecosystem/tcp_ip_layers/tcp_ip_whiteboard.png';
import curl_2 from '@/assets/images/digital_learning_ecosystem/tcp_ip_layers/curl_4.png';
import gui_sketch from '@/assets/images/digital_learning_ecosystem/tcp_ip_layers/gui_sketch_2.png';
import tcp_layer from '@/assets/images/digital_learning_ecosystem/tcp_ip_layers/layers_tcp_1.png';
import rpg_objects_sketch_1 from '@/assets/images/digital_learning_ecosystem/oop_1/rpg_objects_sketch_1.png';
export default 
[

  { id: 1, 
    accordionId: 2, 
    title: 'Version 1 – Ebook as pdf/slides', 
    subtitle:'A-level',
    description: 'Static diagrams explain the theory but provide limited interaction with the underlying processes.',
    image: tcp_layer
  },


  { id: 2, 
    accordionId: 2, 
    title: 'Version 2 - Whiteboard + Annotation', 
    subtitle:'A-level',
    description: 'Annotating screenshots and drawing over diagrams during the lesson encouraged discussion and highlighted the key stages of communication.',
    image:version_2
    },
    { id: 3, 
    accordionId: 2, 
    title: 'Version 3 - Ubuntu Terminal', 
    subtitle:'A-level',
    description: 'Using curl -v allowed students to observe a real TLS handshake, certificate verification, HTTP request, and server response. Although technically demanding, this provided an authentic learning experience with teacher guidance.',
    image: curl_2
    },

     { id: 4, 
    accordionId: 2, 
    title: 'Version 4 – Prototype', 
    subtitle:'A-level',
    description: 'The above suggested GUI could simplify the terminal output by highlighting only the key networking stages, making the activity more accessible while preserving authenticity.',
    image: gui_sketch
    },

    { id: 4, 
    accordionId: 1, 
    title: 'Simple Object Diagram for basic role play game (RPG)', 
    subtitle:'A-level/IBDB',
    description: 'The simple object diagram encourages students to explore why relationships exist between objects rather than simply accepting them. By discussing how objects communicate, depend on one another, and exchange information, students begin to develop an early mental model of object-oriented systems before learning formal UML notation or writing code. This helps them understand that software design is about modelling real-world interactions, not just creating classes.',
    image: rpg_objects_sketch_1
    },



]



/*
698 × 342 ≈ 2:1

So you can also use:

700 × 350
600 × 300
800 × 400
1000 x 600

736 x 412  for drawio and take everthing inside icluding the drawio scale

*/